import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import loginBanner from '../assets/images/login-banner.gif';
import LandingPageHeader from '../Layouts/LandingPageHeader';
import { notifySet, userSet } from '../Services/Actions/CommonActions';
import {
  renderField,
  required,
  email,
  passwordExtraMatches,
} from '../common/helpers/form-validations';
import { login } from '../Services/Utils/UserApis';
import { isEmpty, storeUser } from '../Services/config/globals';
import { store } from '../Services/Store/Store';
import { getCategories } from '../Services/Utils/ServiceProviderApis';

function Login(props) {
  const [type, setType] = useState('password');
  const [passShow, setPassShow] = useState(true);

  const handleType = () => {
    if (type === 'text') {
      setType('password');
      setPassShow(true);
    } else if (type === 'password') {
      setType('text');
      setPassShow(false);
    }
  };
  const {
    handleSubmit, invalid, submitting, pristine
  } = props;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);

  useEffect(() => {
    if (window.location.pathname.match('/login') || window.location.pathname === '/forgot-password') {
      if (!isEmpty(user)) {
        if (user.view.roleView.id === 1) {
          navigate('/startups');
        } else {
          if (user.view.tempPassword === true) {
            navigate('/confirm-password');
          }
          getCategories({ active: true }, { start: 0, recordSize: '' }, 'private').then((category) => {
            if (user.view.tempPassword === false) {
              navigate(`/category/${category?.list[0]?.name}/${category?.list[0]?.id}`);
            }
          });
        }
      }
    }
  }, []);

  const onSubmit = (formData) => {
    const data = {
      loginId: formData.email,
      password: formData.password,
    };
    login(data).then( async (res) => {
      if (res.status === true) {
        storeUser(res);
        store.dispatch(userSet(res));
        if (res.view.roleView.id === 1) {
          navigate('/startups');
        } else {
          if (res.view.tempPassword === true) {
            navigate('/confirm-password');
          }
          await getCategories({ active: true }, { start: 0, recordSize: '' }, 'private').then((category) => {
            if (res.view.tempPassword === false) {
              navigate(`/category/${category?.list[0]?.name}/${category?.list[0]?.id}`);
            }
          });
        }
        setTimeout(() => {
          dispatch(notifySet({ type: 'success', message: 'Signed In Successfully' }));
        }, 1000);
      } else if (res.status === -1) {
        dispatch(notifySet({ type: 'error', message: res.message }));
      }
    });
  };

  return (
    <div id="fullpage" className="fullpage-wrapper">
      <LandingPageHeader />
      <div className="section">
        <div className="container-fluid banner-top-con full-height-section">
          <div className="container h-100">
            <div className="row h-100">
              <div className="col-sm-12 col-md-12 col-lg-6 align-self-center">
                <div className="banner-cap-left banner-top banner-top-sm">
                  <img alt="" src={loginBanner} />
                </div>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-6 align-self-center">
                <div className="banner-cap-right caption-block title-bg-text">
                  <h1>
                    <span>STARTUP</span> <br />
                    <span>LOGIN</span>
                    <br />
                  </h1>
                  <div>
                    <form onSubmit={handleSubmit(onSubmit)} form="loginForm">
                      <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <div className="form-group">
                            <label htmlFor="emailId">
                              Email ID
                              <span className="validation-icon">*</span>
                            </label>
                            <Field
                              type="text"
                              component={renderField}
                              id="emailId"
                              name="email"
                              className="form-control"
                              placeholder="abc@xyz.com"
                              validate={[required, email]}
                            />
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <div className="form-group">
                            <label htmlFor="password">
                              Password{' '}
                              <span className="validation-icon">*</span>
                            </label>
                            <div className="password-icon-fixd">
                              <Field
                                type={type}
                                component={renderField}
                                id="password"
                                name="password"
                                className="form-control"
                                placeholder="Enter password"
                                validate={[required, passwordExtraMatches]}
                              />
                              <div
                                className="password-icon"
                                onClick={handleType}
                              >
                                {passShow ? (
                                  <VisibilityIcon />
                                ) : (
                                  <VisibilityOffIcon />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <div className="form-group">
                            <div className="btn-con xs-full-btn mt-1">
                              <span className="me-4">
                                <Button
                                  type="submit"
                                  className="btn btn-red btn-xs"
                                  variant="contained"
                                  disabled={invalid || submitting || pristine}
                                >
                                  View Deals
                                </Button>
                              </span>
                              <span>
                                <Link
                                  className="link-text"
                                  to="/forgot-password"
                                >
                                  Forgot password
                                </Link>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const withForm = reduxForm({
  enableReinitialize: true,
  form: 'loginForm',
});

export default withForm(Login);
